import type { IHttpClient } from '@wix/http-client'
import type { Schema } from '@wix/wix-data-schema-types'
import type { Logger } from '@wix/wix-data-client-common-standalone'

import { type EnterpriseInfo, getEnterpriseInfo } from './getEnterpriseInfo'

const extractEnterpriseBrandName = (enterpriseInfo?: EnterpriseInfo) =>
  enterpriseInfo?.data?.brand?.name ?? undefined

type EnterpriseBrandName = string | undefined
export type EnterpriseBrandNameGetter = () => Promise<EnterpriseBrandName>

const getEnterpriseBrandName = async (httpClient: IHttpClient) => {
  try {
    const info = await getEnterpriseInfo(httpClient)
    const brandName = await extractEnterpriseBrandName(info)
    return brandName
  } catch (error) {
    throw new Error('Failed to get enterprise brand name', {
      cause: error,
    })
  }
}

export const createEnterpriseBrandNameGetter = (
  httpClient: IHttpClient,
): EnterpriseBrandNameGetter => {
  let enterpriseBrandNamePromise:
    | ReturnType<EnterpriseBrandNameGetter>
    | undefined = undefined

  return () => {
    if (!enterpriseBrandNamePromise) {
      enterpriseBrandNamePromise = getEnterpriseBrandName(httpClient)
    }

    return enterpriseBrandNamePromise
  }
}

export const createSharedSchemasEnterpriseBrandNameGetter = (
  getEnterpriseBrandName: EnterpriseBrandNameGetter,
  logger: Logger,
) => {
  let enterpriseBrandName: EnterpriseBrandName = undefined

  return async ({ schemas }: { schemas: Schema[] }) => {
    if (
      !enterpriseBrandName &&
      schemas.some(schema => !!schema.plugins?.shared)
    ) {
      try {
        enterpriseBrandName = await getEnterpriseBrandName()
      } catch (error) {
        logger.error(
          new Error('sharedSchemasEnterpriseBrandNameGetter failed', {
            cause: error,
          }),
        )
      }
    }

    return enterpriseBrandName
  }
}
